<template>
  <div class="wrapper">
    <Topbar></Topbar>
    <Banner></Banner>
    <div class="nav">
      <div class="nav-tab">
        <router-link :class="current1000 ? 'current' : ''" :to="{path:'/main',query:{c:'Centiare', centiare:'THOUSAND', contentID: 13}}">1000平方米展厅资料</router-link>
        <router-link :class="current500 ? 'current' : ''" :to="{path:'/main',query:{c:'Centiare', centiare:'FIVE_HUNDRED', contentID: 30}}">500平方米展厅资料</router-link>
      </div>
      <div class="nav-list">
        <a v-for="item in navList" :key="item.value" href="javascript:void(0)" :class="listCurrent == item.id ? 'list-current' : ''" @click="getContent(item.id,item.type,'Centiare')">{{item.name}}</a>
      </div>
    </div>
    <component :is="current"></component>
    <Footer></Footer>
    <el-dialog customClass="login-form" title="特别提醒" :visible.sync="dialogRemind" :close-on-click-modal="false" :append-to-body="true" width="500px" :center="true">
      <!-- <p>请各级单位在展览版式的“结束语”图文版上增加文字：部分资料来源为”老科学家学术成长资料采集工程”</p> -->
      <p>1.请各级单位在展览板式的“结束语”图文版上增加文字：部分资料来源为“老科学家学术成长资料采集工程”；</p>
      <p>2.请各级单位在展览板式的第四部分的“青春无悔大三线”单元的图文版上，替换并使用《三线建设区域划分示意图》的新文件。</p>
    </el-dialog>
  </div>
</template>

<script>
import { getDatabankList } from '@/api/databank'

// @ is an alias to /src
import Banner from '@/components/Banner.vue'
import Topbar from '@/components/Topbar.vue'
import Footer from '@/components/Footer.vue'
import Centiare from '@/components/Centiare.vue'
import DownloadLog from '@/components/DownloadLog.vue'

export default {
  name: 'MainView',
  components: {
    Banner,
    Topbar,
    Footer,
    Centiare,
    DownloadLog
  },
  data() {
    return {
      current: '',
      navList: null,
      listType: '',
      contentID: 0,
      current1000: false,
      current500: false,
      listCurrent: -1,
      dialogRemind: true
    }
  },
  mounted() {
    // 动态载入组件
    this.current = this.$route.query.c
    this.$store.state.centiare = this.$route.query.centiare
    this.listCurrent = this.$route.query.contentID
    if(this.$route.query.centiare == 'THOUSAND'){
      this.current1000 = true
      this.current500 = false
    } else if(this.$route.query.centiare == 'FIVE_HUNDRED') {
      this.current1000 = false
      this.current500 = true
    }
    this.getDatabank()
  },
  watch: {
    $route(){
      this.current = this.$route.query.c
      this.$store.state.centiare = this.$route.query.centiare
      this.listCurrent = this.$route.query.contentID
      if(this.$route.query.centiare == 'THOUSAND'){
        this.current1000 = true
        this.current500 = false
      } else if(this.$route.query.centiare == 'FIVE_HUNDRED') {
        this.current1000 = false
        this.current500 = true
      }
      this.getDatabank()
    },
    
  },
  methods: {
    getDatabank(){
      getDatabankList({
        pageSize: 50,
        pageNum: 1,
        type: this.$route.query.centiare,
        orderType: 'idAsc'
      }).then(res => {
        this.contentID = this.$route.query.contentID
        this.navList = res.data.rows
      })
    },
    // 获取内容
    getContent(contentID,contentType,contentCurrent){
      this.listCurrent = contentID
      this.$route.query.c
      this.$route.query.centiare
      this.$router.push({
        query: {'c':contentCurrent,'centiare':contentType,'contentID':contentID}
      })
      this.current = 'Centiare'
      this.contentID = contentID
    }
  }
}
</script>

<style scoped>
.wrapper {
  overflow: hidden;
}
.nav {
  padding: 50px 0 60px;
  text-align: center;
  padding: 0 60px;
  background: #c01509;
}
.nav-tab {
  display: flex;
  padding-bottom: 20px;
}
.nav-tab a {
  color: #ffd79c;
  height: 64px;
  line-height: 64px;
  text-align: center;
  width: 230px;
  font-size: 22px;
  display: block;
  font-weight: bold;
}
.nav-tab a.current {
  background-color: #ffd79c;
  color: #c01509;
}
.nav-list {
  text-align-last: left;
  overflow: hidden;
}
.nav-list a {
  color: #fff;
  display: block;
  font-size: 16px;
  margin-right: 40px;
  float: left;
  margin-bottom: 15px;
}
.nav-list a.list-current {
  color: #ffd79c;
}
.login-form p {
  font-size: 24px;
  line-height: 50px;
}
</style>
